import {createApp} from 'vue';
import {VueReCaptcha} from 'vue-recaptcha-v3';

import App from './App.vue';
import router from './router';
import store from './store';
import globalMethods, {setStore} from './globalMethods.js';
import notification from './plugins/notification';
import i18n from "@/i18n";
import {installChunkErrorHandlers} from '@/utils/chunkReload';


import './registerServiceWorker';
import './app.css';
import 'quill/dist/quill.snow.css';


installChunkErrorHandlers(router);
setStore(store);
const app = createApp(App);
app.config.globalProperties.$globalMethods = globalMethods;
app.use(store).use(router).use(notification, store).use(i18n).use(VueReCaptcha, {siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY}).mount('#app');
